import {
    ChangeDetectorRef,
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { KEY_CODE } from '@reg/shared/key-codes';

declare let google: any;

@Directive({
    selector: '[floGooglePlacesSearch]',
})
export class GooglePlacesSearchDirective implements OnInit {
    @Output() public placeChange: EventEmitter<Object> = new EventEmitter<Object>();
    // https://developers.google.com/places/supported_types
    @Input() public placeTypes: string[];
    private previousPlace: any;

    constructor(
                public el: ElementRef,
                private ref: ChangeDetectorRef,
    ) {
    }

    @HostListener('keyup')
    public keyup($event: any): void {
        if (!this.el.nativeElement.value) {
            // No value in the textbox so clear the google place
            this.changePlace(null);
        }
    }

    @HostListener('keypress')
    public keypress($event: any): void {
        // The user is most likely hitting the enter key to select
        // a google place so make sure the do not submit the form
        if (event['keyCode'] === KEY_CODE.KEY_RETURN) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    public ngOnInit(): void {
        this.configureGooglePlacesAutocomplete();
    }

    /**
     * Configure the location search box to display Google places
     * autocomplete options when the user types.
     */
    public configureGooglePlacesAutocomplete(): void {
        try {
            const options: any = {};

            if (this.placeTypes && this.placeTypes.length > 0) {
                options.types = this.placeTypes;
            }

            // Initialize the search box and autocomplete
            const autocomplete: any = new google.maps.places.Autocomplete(this.el.nativeElement, options);

            // Add listener to the place changed event
            autocomplete.addListener('place_changed', () => {
                this.changePlace(autocomplete.getPlace());
            });
        } catch (e) {
            const err: string = `Failed to configure Google Place's autocomplete. Error: ${e.toString()}`;
            console.error(err);
        }
    }

    private changePlace(place?: any): void {
        if (place === this.previousPlace) {
            return;
        }

        this.previousPlace = place;

        this.placeChange.emit(place);

        this.ref.detectChanges();
    }
}
